import { useState } from 'react';

function MeanStackModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Web Development",
      content: [
        "Understanding the basics of Web Development.",
        "Overview of Web technologies and their roles.",
        "How browsers work: Rendering HTML, CSS, and JavaScript.",
        "Introduction to client-side and server-side development."
      ]
    },
    {
      title: "Module 2: HTML Basics",
      content: [
        "HTML Document structure: DOCTYPE, <html>, <head>, <body>.",
        "Common HTML elements: <div>, <span>, <h1>-<h6>, <p>, <a>, <img>, <form>.",
        "Forms in HTML: Input types, submitting data, and validation.",
        "Semantic HTML: <header>, <nav>, <footer>, <article>, <section>."
      ]
    },
    {
      title: "Module 3: CSS Fundamentals",
      content: [
        "CSS Syntax: Selectors, Properties, and Values.",
        "Box Model: margin, padding, border, content.",
        "Positioning in CSS: static, relative, absolute, fixed, sticky.",
        "Responsive Design: Media Queries, Flexbox, Grid Layout."
      ]
    },
    {
      title: "Module 4: JavaScript Basics",
      content: [
        "Introduction to JavaScript: Variables, Data Types, and Operators.",
        "Control Flow: if, else, switch, for, while loops.",
        "Functions in JavaScript: Declaring and calling functions.",
        "DOM Manipulation: Selecting and modifying elements on the page.",
        "Event Handling: Click events, form submissions, mouseover, etc."
      ]
    },
    {
      title: "Module 5: Advanced JavaScript",
      content: [
        "Objects and Arrays: Creating and manipulating them.",
        "JavaScript ES6 features: Arrow functions, Template literals, Spread and Rest operators.",
        "Asynchronous JavaScript: Callbacks, Promises, async/await.",
        "Error Handling: try/catch blocks, custom error messages."
      ]
    },
    {
      title: "Module 6: Introduction to Angular",
      content: [
        "What is Angular? Overview of Angular's MVC architecture.",
        "Setting up an Angular project: Installing Angular CLI and creating your first app.",
        "Components in Angular: Understanding Angular components, decorators, and templates.",
        "Directives and Pipes in Angular: Custom and built-in directives, transforming data with pipes.",
        "Services and Dependency Injection: Understanding services, injecting them into components."
      ]
    },
    {
      title: "Module 7: Angular Routing",
      content: [
        "Setting up Routing in Angular: Creating routes and linking them with <router-outlet>.",
        "Navigating between components using Angular Router.",
        "Route Guards: Protecting routes and handling authorization.",
        "Lazy Loading in Angular: Optimizing application performance by loading modules on demand."
      ]
    },
    {
      title: "Module 8: Angular Forms",
      content: [
        "Template-Driven Forms: Creating and managing forms with Angular's built-in directives.",
        "Reactive Forms: Using FormGroup, FormControl, and FormBuilder for dynamic form creation.",
        "Validation in Angular Forms: Built-in validations and custom validators."
      ]
    },
    {
      title: "Module 9: Introduction to Node.js and Express.js",
      content: [
        "What is Node.js? Setting up the Node.js environment.",
        "Understanding npm: Installing and managing packages.",
        "Building a simple server with Express.js.",
        "Routing in Express.js: GET, POST, PUT, DELETE methods.",
        "Middleware in Express.js: Custom and built-in middleware."
      ]
    },
    {
      title: "Module 10: MongoDB Basics",
      content: [
        "What is MongoDB? Introduction to NoSQL databases.",
        "Setting up MongoDB: Installing and configuring MongoDB.",
        "CRUD Operations in MongoDB: Create, Read, Update, Delete.",
        "MongoDB Queries: Filtering data with find(), sort(), and limit().",
        "Connecting MongoDB with Node.js using Mongoose."
      ]
    },
    {
      title: "Module 11: Full-Stack Development with MEAN",
      content: [
        "Setting up the MEAN stack: Integrating MongoDB, Express, Angular, and Node.js.",
        "Building REST APIs with Express: CRUD operations with a backend Node.js server.",
        "Frontend with Angular: Fetching data from backend APIs and displaying it in Angular components.",
        "Connecting Angular frontend with Express backend via HTTP requests.",
        "Building a simple full-stack application with MEAN."
      ]
    },
    {
      title: "Module 12: Authentication in MEAN Stack",
      content: [
        "Introduction to Authentication: Using Sessions and JWT.",
        "Setting up User Authentication with JWT in Express.",
        "Register and Login Routes: Hashing passwords with bcrypt.",
        "Protecting Routes: Middleware to check for valid JWT.",
        "Session Management and Authorization in Angular."
      ]
    },
    {
      title: "Module 13: Deployment and Best Practices",
      content: [
        "Deploying a MEAN Stack Application on Heroku or AWS.",
        "Setting up a Production Environment in Node.js.",
        "Using Environment Variables for Configuration.",
        "Performance Optimization for MEAN Apps.",
        "Best Practices in Full-Stack Development."
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">MEAN Stack Course Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px', color: '#333' }}>
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MeanStackModule;
